import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { removeAccessToken } from "../../Util/token";

import { logo, Scofa_Knowledge_Base_Logo_White, userImage } from "./../../Assets/images/";

import { Navbar, Container, Nav, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faBars,
  faEllipsisV,
  faSignOut,
  faKey,
} from "@fortawesome/free-solid-svg-icons";

import "./style.css";
import { questionModal, successModal } from "../../Components/CustomModal";

export const Header = (props) => {
  const navigate = useNavigate();
  const location = useLocation();


  const handleLogout = async (e) => {
    e.preventDefault();
    removeAccessToken()
    navigate("/login");
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    questionModal.fire({
      title: `Do you want to reset password?`,
      confirmButtonText: `continue`,
    }).then((result) => {
      if (result.isConfirmed) {
        removeAccessToken()
        navigate("/recover-password");
      }
    });
  };

  const isScofaDashboard = location.pathname.includes("/scofa");
  return (
    <header>
      <Navbar className="customHeader" expand="md">
        <Container fluid>
          {isScofaDashboard ? (
            <Link to={"/scofa-dashboard"} className="siteLogo order-2 order-lg-1">
              <img style={{ width: "125px" }} src={Scofa_Knowledge_Base_Logo_White} alt="Logo" />
            </Link>
          ) : (
            <Link  to={"/dashboard"} className="siteLogo order-2 order-lg-1">
              <img src={logo} alt="Logo" />
            </Link>
          )}
          {/* <Link to={"/dashboard"} className="siteLogo order-2 order-lg-1">
            <img src={isScofaDashboard ? Scofa_Knowledge_Base_Logo_White : logo} alt="Logo" />
          </Link> */}
          <Navbar.Toggle className="order-4 order-lg-2 notButton">
            <FontAwesomeIcon className="bell-icon" icon={faEllipsisV} />
          </Navbar.Toggle>
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="customCollapse order-3"
          >
            <Nav className="ms-auto">
              <Link className={`sideLink bide-bar-menu  ${location.pathname.includes("/scofa-dashboard") ? "active" : ""} `}
                to={isScofaDashboard ? "/dashboard" : "/scofa-dashboard"} >
                View {isScofaDashboard ? "Relax Dashboard" : "Scofa Dashboard"}
              </Link>
              <Dropdown className="userDropdown">
                <Dropdown.Toggle
                  variant="transparent"
                  className="notButton toggleButton text-white"
                >
                  <div className="userImage">
                    <img src={userImage} alt="" className="img-fluid" />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="userMenu" align="end">
                  {/* <Link className="userMenuItem" to={"/profile"}>
                    <FontAwesomeIcon
                      className="me-2 yellow-text"
                      icon={faUser}
                    />{" "}
                    Profile
                  </Link> */}
                  <button className="userMenuItem" onClick={handleLogout}>
                    <FontAwesomeIcon
                      className="me-1 yellow-text"
                      icon={faSignOut}
                    />{" "}
                    Logout
                  </button>
                  <button className="userMenuItem" onClick={resetPassword}>
                    <FontAwesomeIcon
                      className="me-1 yellow-text"
                      icon={faKey}
                    />{" "}
                    Reset Passowrd
                  </button>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
          <button className="notButton ms-md-2 order-lg-4 order-md-4 order-1">
            <FontAwesomeIcon
              className="bell-icon text-white"
              onClick={props.sidebarToggle}
              icon={faBars}
            />
          </button>
        </Container>
      </Navbar>
    </header>
  );
};
